/**
 * @desc 自定义指令
 */
import infiniteScroll from './infiniteScroll'
import mask from './mask'
// 权限按钮控制
export default {
  power: {
    inserted: function(el, value) {
      if (value.value === 'd') {
        el.parentNode.removeChild(el)
      }
    },
  },
  loadmore: {
    bind (el, binding) {
      const handle = function () {
        const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight
        if (CONDITION) {
          binding.value()
        }
      }
      el.__vueClickOutside__ = handle
      // 获取element-ui定义好的scroll盒子
      const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
      SELECTWRAP_DOM.addEventListener('scroll', handle)
    },
    unbind (el, binding) {
      // 解除事件监听
      const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
      SELECTWRAP_DOM.removeEventListener('click', el.__vueClickOutside__)
      delete el.__vueClickOutside__
    },
  },
  clickoutside: {
    // 初始化指令
    bind (el, binding, vnode) {
      function documentHandler (e) {
        // 这里判断点击的元素是否是本身，是本身，则返回
        if (el.contains(e.target)) {
          return false
        }
        // 判断指令中是否绑定了函数
        if (binding.expression) {
          // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
          binding.value(e)
        }
      }
      // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
      el.__vueClickOutside__ = documentHandler
      document.addEventListener('click', documentHandler)
    },
    update () { },
    unbind (el, binding) {
      // 解除事件监听
      document.removeEventListener('click', el.__vueClickOutside__)
      delete el.__vueClickOutside__
    },
  },
  // 滚动加载
  infiniteScroll,
  mask,
}
